import { render } from "./DistributeDocument.vue?vue&type=template&id=07f28050"
import script from "./DistributeDocument.vue?vue&type=script&lang=js"
export * from "./DistributeDocument.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__